module.exports = __webpack_public_path__ + "img/8.6a6ea393.jpg";